class HitButtons {
    constructor(hit) {
        this.hit = hit;
    }

    buttons() {
        let buttons = [];

        let dnaExplorerButton = this.dnaExplorerBtn();
        if (dnaExplorerButton) buttons.push(dnaExplorerButton);

        return buttons;
    }

    dnaExplorerBtn() {
      if (!this.hitOnNucleotideDatabase(this.hit.props.algorithm)) {
        return null;
      }

      return {
            text: 'Explore DNA Features',
            icon: 'fa-flask',
            className: 'download-fa',
            onClick: (evt) => this.exploreDnaFeatures(evt)
      };
    }

    // Given an algorithm, return true if the hit originates from a nucleotide database.
    hitOnNucleotideDatabase(algorithm) {
        return algorithm == 'blastn' || algorithm == 'tblastx' || algorithm == 'tblastn';
    }

    exploreDnaFeatures(evt) {
      evt.target.classList.add('disabled');
      evt.target.disabled = true;
      evt.target.textContent = 'Preparing annotations...'

      const path = this.hit.viewSequenceLink();
      fetch(path)
        .then(response => response.json())
        .then(data => {
          const sequence = data.sequences[0].value;

          const url = '/dna-feature-explorer/sequence';
          const formData = new FormData();
          formData.append('sequence', sequence);
          formData.append('id', sessionStorage.getItem('job_id'));
          formData.append('hit_id', this.hit.sequenceID());
          fetch(url, {
            method: 'POST',
            body: formData,
            redirect: 'follow'
          }).then(response => {
              if (response.ok) {
                return response.url;
              } else {
                throw new Error('Unexpected response status: ' + response.status);
              }
          })
          .then(redirectUrl => {
              window.location.href = redirectUrl;
          })
          .catch(error => {
              console.error('Error:', error);
          });

        });
    }
}

export default HitButtons;